import {
    UpdateMemberDetailsFormProps,
    FieldFormatType,
    ButtonSize,
    ButtonColor,
    ButtonIconPosition,
} from '@vista-digital/occ-ui'
import { defaultUpdateMemberDetailsFormProps } from '@vista-digital/occ-ui/src/lib/components/member/update-details-form/types/props'

export const updateMemberFormProps: UpdateMemberDetailsFormProps = {
    ...defaultUpdateMemberDetailsFormProps,
    config: {
        cancelButton: {
            show: false,
            size: ButtonSize.Medium,
            color: ButtonColor.Secondary,
            iconPosition: ButtonIconPosition.Right,
        },
        submitButton: {
            show: true,
            size: ButtonSize.Medium,
            color: ButtonColor.Primary,
            iconPosition: ButtonIconPosition.Right,
        },
        validation: {
            givenName: {
                type: FieldFormatType.Text,
                required: true,
            },
            familyName: {
                type: FieldFormatType.Text,
                required: true,
            },
            gender: {
                type: FieldFormatType.Other,
                required: true,
            },
            dateOfBirth: {
                type: FieldFormatType.Date,
                required: true,
            },
            mobileNumber: {
                type: FieldFormatType.Text,
                required: true,
            },
            primarySite: {
                type: FieldFormatType.Other,
                required: true,
            },
            address: {
                type: FieldFormatType.Text,
                required: false,
            },
            city: {
                type: FieldFormatType.Text,
                required: false,
            },
            state: {
                type: FieldFormatType.Text,
                required: false,
            },
            postCode: {
                type: FieldFormatType.Text,
                required: true,
            },
            /** Unused */
            homeNumber: {
                type: FieldFormatType.Text,
                required: false,
            },
            nationalId: {
                type: FieldFormatType.Text,
                required: false,
            },
            externalId: {
                type: FieldFormatType.Text,
                required: false,
            },
            suburb: {
                type: FieldFormatType.Text,
                required: false,
            },
            favouriteGenres: {
                type: FieldFormatType.Other,
                required: false,
            },
            newsletter: {
                type: FieldFormatType.Other,
                required: false,
            },
            termsAndConditions: {
                type: FieldFormatType.Other,
                required: false,
            },
            captcha: {
                type: FieldFormatType.Other,
                required: false,
            },
            allowThirdPartyContact: {
                type: FieldFormatType.Other,
                required: false,
            },
            allowThirdPartyProfiling: {
                type: FieldFormatType.Other,
                required: false,
            },
        },
    },
}
